var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"y13xb4Bl-ULx14W_ahSwT"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["node_ui@buzzfeed-6q"]={id:"y13xb4Bl-ULx14W_ahSwT"};
      